import React, {useContext, useState} from "react";
import {AuthContext, getLoggedInUser} from "contexts/auth/auth.provider";
import {useFormik} from "formik";
import * as Yup from 'yup';
import clsx from "clsx";
import {useRouter} from "next/router";
import {Logo} from "components/logos";
import {Google} from "components/Icons";
import BlockUi from "react-block-ui";
import notifications from "utils/notifications";
import {withApollo} from "helper/apollo";

const countries = [{
    id: 'ZA', label: "South Africa", currency: 'ZAR'
}];

const IndexPage = ({country}) => {
    const router = useRouter();
    const [done, setDone] = useState(false);

    const {signUp, loading, federatedSignIn} = useContext<any>(AuthContext);
    const [initValues,] = useState({
        email: '',
        password: '',
        firstName: '',
        lastName: '',
    });

    function onFederated(provider) {
        federatedSignIn({
            provider,
            customState: {
                a: 1
            }
        }).then(() => {
            router.push('/');
        })
            .catch(e => console.log(e))
    }

    const handleSignup = (values) => {

        const {firstName, lastName, email, password} = values;
        signUp({
            email,
            password,
            firstName,
            lastName,
        }).then(() => {
            setDone(true);
        }).catch((e) => notifications.error(e.message, `Error`, 7000));


    };

    const getValidationSchema = () => {
        return Yup.object().shape({
            firstName: Yup.string()
                .required('First name is required'),
            lastName: Yup.string()
                .required('Last name is required'),
            email: Yup.string()
                .email('Invalid email')
                .required('Email is required'),
            password: Yup.string()
                .min(8, 'Password must be at least 8 characters')
                .required('Password is required'),
        });
    };


    const {getFieldProps, handleSubmit, errors, touched, isValid,} = useFormik({
        enableReinitialize: true,
        initialValues: initValues,

        onSubmit: handleSignup,
        validationSchema: getValidationSchema()
    });

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <Logo
                    className="mx-auto h-12 w-auto"

                />
                <h2 className="mt-6 text-center text-3xl leading-9 font-extrabold text-gray-900">
                    Sign up for an account
                </h2>
                <p className="mt-2 text-center text-sm leading-5 text-gray-600 max-w">
                    Or&nbsp;
                    <a
                        href="/rent/auth/login"
                        className="font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:underline transition ease-in-out duration-150"
                    >
                        log in here
                    </a>
                </p>
            </div>
            <BlockUi tag={"div"} blocking={loading} className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                {done && <div
                    className="bg-white rounded-lg px-4 pt-5 pb-8 overflow-hidden shadow-xl transform transition-all "
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="modal-headline"
                >
                    <div>
                        <div className="mt-3 text-center sm:mt-5">
                            <h3
                                className="text-lg leading-6 font-medium text-gray-900"
                                id="modal-headline"
                            >
                                Thank you, please check your email.
                            </h3>
                            <div className="mt-2">
                                <p className="text-sm leading-5 text-gray-500">
                                    We've sent an email to verify your email address.
                                </p>
                            </div>
                        </div>
                    </div>

                </div>}

                {
                    !done && <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                        <form onSubmit={handleSubmit}>
                            <div className="mt-2 grid grid-cols-2 gap-3">
                                <div>
                                    <label
                                        htmlFor="email"
                                        className="block text-sm font-medium leading-5 text-gray-700"
                                    >
                                        First Name
                                    </label>
                                    <div className="mt-1 rounded-md shadow-sm">
                                        <input
                                            {...getFieldProps('firstName')}
                                            className={
                                                clsx(touched.firstName && errors.firstName && 'border-red-300 text-red-900', "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5")
                                            }/>
                                        {touched.firstName && errors.firstName && <div
                                            className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                            <svg className="h-5 w-5 text-red-500" fill="currentColor"
                                                 viewBox="0 0 20 20">
                                                <path fill-rule="evenodd"
                                                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                                      clip-rule="evenodd"/>
                                            </svg>
                                        </div>}

                                    </div>
                                    {touched.firstName && errors.firstName &&
                                    <p className="mt-2 text-sm text-red-600" id="email-error">{errors.firstName}</p>}
                                </div>
                                <div>
                                    <label
                                        htmlFor="email"
                                        className="block text-sm font-medium leading-5 text-gray-700"
                                    >
                                        Last Name
                                    </label>
                                    <div className="mt-1 rounded-md shadow-sm">
                                        <input
                                            {...getFieldProps('lastName')}
                                            className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                        />
                                    </div>
                                    {touched.lastName && errors.lastName &&
                                    <p className="mt-2 text-sm text-red-600" id="email-error">{errors.lastName}</p>}
                                </div>
                            </div>

                            <div className="mt-6">
                                <label
                                    htmlFor=" email"
                                    className=" block text-sm font-medium leading-5 text-gray-700"
                                >
                                    Email address
                                </label>
                                <div className=" mt-1 rounded-md shadow-sm">
                                    <input
                                        {...getFieldProps('email')}
                                        id="email"
                                        type="email"
                                        required
                                        className=" appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md
                             placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300
                             transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                    />
                                </div>
                                {touched.email && errors.email &&
                                <p className="mt-2 text-sm text-red-600" id="email-error">{errors.email}</p>}
                            </div>

                            <div className=" mt-6">
                                <label
                                    htmlFor=" password"
                                    className=" block text-sm font-medium leading-5 text-gray-700"
                                >
                                    Password
                                </label>
                                <div className=" mt-1 rounded-md shadow-sm">
                                    <input
                                        {...getFieldProps('password')}
                                        id="password"
                                        type="password"
                                        required
                                        className=" appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md
                             placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300
                             transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                    />
                                </div>
                                {touched.password && errors.password &&
                                <p className="mt-2 text-sm text-red-600" id="email-error">{errors.password}</p>}
                            </div>


                            <div className="mt-6">
                              <span className="block w-full rounded-md shadow-sm">
                                <button
                                    type="submit"
                                    className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out"
                                >
                                  Sign up
                                </button>
                              </span>
                            </div>
                        </form>
                        <div className="mt-6">
                            <div className="relative">
                                <div className="absolute inset-0 flex items-center">
                                    <div className="w-full border-t border-gray-300"/>
                                </div>
                                <div className="relative flex justify-center text-sm leading-5">
                                <span className="px-2 bg-white text-gray-500">
                                  Or continue with
                                </span>
                                </div>
                            </div>
                            <div className="mt-6 grid grid-cols-2 gap-3">
                                <div>
                                <span className="w-full inline-flex rounded-md shadow-sm">
                                  <button
                                      onClick={(e) => {
                                          e.preventDefault();
                                          onFederated('Facebook');
                                      }}
                                      className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition duration-150 ease-in-out"
                                      aria-label="Sign in with Facebook"
                                  >
                                    <svg
                                        className="w-5 h-5"
                                        fill="currentColor"
                                        viewBox="0 0 20 20"
                                    >
                                      <path
                                          fillRule="evenodd"
                                          d="M20 10c0-5.523-4.477-10-10-10S0 4.477 0 10c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V10h2.54V7.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V10h2.773l-.443 2.89h-2.33v6.988C16.343 19.128 20 14.991 20 10z"
                                          clipRule="evenodd"
                                      />
                                    </svg>
                                  </button>
                                </span>
                                </div>

                                <div>
                                <span className="w-full inline-flex rounded-md shadow-sm">
                                  <button
                                      onClick={(e) => {
                                          e.preventDefault();
                                          onFederated('Google');
                                      }}
                                      className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition duration-150 ease-in-out"
                                      aria-label="Sign in with Google"
                                  >
                                    <Google/>
                                  </button>
                                </span>
                                </div>


                            </div>
                        </div>
                    </div>
                }
            </BlockUi>
        </div>

    )
}

export async function getServerSideProps(context) {
    const user = await getLoggedInUser(context);
    if (user) {
        if (context.res) {
            const redirect = `/rent/camping`;
            context.res.writeHead(302, {Location: redirect});
            context.res.end()
            return {props: {}};
        }
    }


    const country = context.req?.headers['cloudfront-viewer-country'] || 'ZA';

    return {props: {country}};
}


export default withApollo(IndexPage);
